import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const AccessoryInstall = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('how_install_accessory'))
        }
    }

    useEffect(postTitle, [])

    return <div className="App"></div>
}

export default AccessoryInstall